import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Carousel.css";

import "swiper/css";
import "swiper/css/navigation";
import Button from "./Button";
import { ReactComponent as LeftArrow } from "./static/icons/LeftArrow.svg";
import { ReactComponent as RightArrow } from "./static/icons/RightArrow.svg";

function Carousel({ images }) {
  return (
    <div className="CarouselContainer">
      <Button id="prev" variant="icon" icon={<LeftArrow />} />
      <Swiper
        style={{ width: 217 }}
        spaceBetween={100}
        slidesPerView={1}
        modules={[Navigation]}
        navigation={{
          nextEl: "#next",
          prevEl: "#prev",
        }}
        loop
        centeredSlides
      >
        {images.map((image) => (
          <SwiperSlide key={image} style={{ width: 217 }}>
            <img src={image} width={217} />
          </SwiperSlide>
        ))}
      </Swiper>
      <Button id="next" variant="icon" icon={<RightArrow />} />
    </div>
  );
}

export default Carousel;
